export const compare = (a, b, precision = 0.00001) => {
    if (Math.abs(a - b) < precision) {
        return 0;
    }
    return a > b ? 1 : -1;
};

export const equals = (...args) => compare(...args) === 0;
